module.exports = __webpack_public_path__ + "img/about-8.01a15d55.png";